import React from 'react';

import ListAbsoluteMain from '@components/listAbsoluteMain/ListAbsoluteMain.tsx';
import ListScroll from '@components/listScroll/ListScroll.tsx';
import LoaderBlock from '@components/loaderBlock/LoaderBlock.tsx';
import { d } from '@functions/seo.ts';

import I from '../types.ts';

const renderContent: I['renderContent'] = function () {
    const {
        isReady,
        items = [],
        isLimit,
        isDisabledScroll,
        isLoadingFilter = false,
        isShowMoreLoader = false,
        counterUpdate,
        contentHeight = 400,
    } = this.state;
    const { setPagesKey } = this.props;

    return (
        <div
            className="publicBlog__content"
            style={{ height: isLoadingFilter ? `${38}rem` : `${contentHeight}px` }}
        >
            <LoaderBlock
                className="publicBlog__loader"
                isShow={!isReady || isLoadingFilter}
                loaderClassName="_main"
            />
            <LoaderBlock
                className="publicBlog__loader _white"
                isShow={!!isReady && !!isShowMoreLoader}
                isScroll={true}
                loaderClassName="_main"
            />

            <ListScroll
                isInit={isReady}
                getParent={this.getScrollParent}
                callback={this.getMoreItems}
                startCounter={this.stepCounter}
                stepCounter={this.stepCounter}
                maxCounter={Infinity}
                lengthCurrent={items.length}
                handlerLoaderList={this.handlerLoaderList}
                isLimit={!!isLimit}
                otherItemsCounter={1}
                isDisabledScroll={isDisabledScroll || !isReady || isLoadingFilter}
                offsetY={() => (d.querySelector('.publicTop._footer') as HTMLElement)?.offsetHeight}
                key={counterUpdate}
            >
                <ListAbsoluteMain
                    className="publicBlog__articles"
                    items={this.getArticlesItems()}
                    renderItem={this.renderArticle}
                    classNameItem="publicBlog__article"
                    prop="_id"
                    paramsParent={{ width: true }}
                    styles={['height']}
                    itemParams={['offsetRight', 'offsetTop', 'width', 'height']}
                    resizeParent={d.querySelector('.body__content') as HTMLElement}
                    minHeight={400}
                    callback={({ type, params }) => {
                        if (type === 'parent') {
                            this.setState({ contentHeight: params!.height }, setPagesKey);
                        } else {
                            setPagesKey();
                        }
                    }}
                    propsForUpdate={['counter']}
                />
            </ListScroll>
        </div>
    );
};

export default renderContent;
